import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url: string | undefined = import.meta.env['VITE_SUPABASE_URL'];
const anonKey: string | undefined = import.meta.env['VITE_SUPABASE_ANON_KEY'];

/**
 * Клиент Supabase нужен для аутентификации и realtime-подписки на прогресс
 * прогонов биллинга. Если переменные окружения не заданы (локальная работа на
 * моках) — возвращаем null, а вызывающий код переходит на опрос по таймеру.
 */
export const supabase: SupabaseClient | null =
  url && anonKey
    ? createClient(url, anonKey, {
        auth: { persistSession: true, autoRefreshToken: true, storageKey: 'wf.supabase.auth' },
        realtime: { params: { eventsPerSecond: 5 } },
      })
    : null;

export function isSupabaseEnabled(): boolean {
  return supabase !== null;
}
